import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=eeb0d2a8&"
import script from "./TagEdit.vue?vue&type=script&lang=ts&"
export * from "./TagEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TagEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports